<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Price Checker</h4>
                <p class="text-subtitle-1">Check Item Prices from different suppliers</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" md="6">
                <v-autocomplete
                    label="Item"
                    :value="itemID"
                    @input="setItemID"
                    :items="items"
                    :loading="itemsLoading"
                    item-text="display_name"
                    @update:search-input="searchItems"
                    item-value="id"
                    outlined
                    dense
                    hide-details>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn color="primary" block :loading="loading" @click="fetch">
                    <v-icon left>mdi-magnify</v-icon>
                    search
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-progress-linear indeterminate v-if="loading"/>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Purchase Order</th>
                            <th>Date</th>
                            <th>Supplier</th>
                            <th>Quantity</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in data" :key="i" v-ripple @dblclick="openPurchaseOrder(d)">
                            <td>
                                <v-btn icon @click="openPurchaseOrder(d)">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                {{d.purchase_order_code}}
                            </td>
                            <td>{{d.date}}</td>
                            <td>{{d.supplier_code}} - {{d.supplier_name}}</td>
                            <td>{{formatNumber(d.quantity, 2)}} {{d.measure_unit}}</td>
                            <td>
                                <span class="font-weight-bold">
                                    {{d.currency}} {{formatNumber(d.price, 2)}}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="data.length == 0">
                            <td colspan="5" class="text-center">
                                <span>
                                    {{loading ? "Loading" : "No Data"}}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { formatNumber } from 'accounting'
import { mapActions, mapState } from 'vuex';
export default {
    computed: {
        ...mapState("purchase/priceChecker", ["itemID", "data", "items", "itemsLoading", "loading"])
    },
    methods: {
        formatNumber,
        ...mapActions("purchase/priceChecker", [
            "fetch", "searchItems", "setItemID"
        ]),
        openPurchaseOrder(row) {
            this.$router.push({
                name: "PurchaseOrderDisplay",
                params: {
                    id: row.purchase_order_id
                }
            })
        }
    }
}
</script>

<style>

</style>